module.exports = __webpack_public_path__ + "img/empty.d2f6fc37.png";